export class Category {
    index: number;
    id: number;
    name: string;
    image: string;
}
